import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const WrenchIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.20089 3.86139C5.26782 3.91044 5.29478 3.99621 5.26999 4.07276C5.08048 4.63234 4.7001 5.15507 4.22649 5.50497C4.15939 5.55379 4.06884 5.5535 4.00235 5.50476L2.50928 4.4105C1.84155 3.92116 0.899117 4.46596 1.00877 5.30008C1.15157 6.38617 1.72978 7.41478 2.6995 8.098C3.45504 8.63033 4.33634 8.86419 5.19777 8.8266C5.76241 8.80199 6.31265 9.01803 6.71424 9.42062L11.9271 14.6462C12.3909 15.1111 13.1404 15.1188 13.6136 14.6636L14.6293 13.6867C15.1164 13.2181 15.1247 12.4396 14.6471 11.9608L9.45375 6.75488C9.05391 6.35404 8.83817 5.80605 8.86099 5.24387C8.91308 3.96071 8.36456 2.66376 7.27075 1.83027C6.32715 1.11124 5.17401 0.870974 4.09833 1.064C3.27206 1.21225 3.04022 2.27782 3.70786 2.76716L5.20089 3.86139ZM12.75 13.5C13.1642 13.5 13.5 13.1642 13.5 12.75C13.5 12.3358 13.1642 12 12.75 12C12.3358 12 12 12.3358 12 12.75C12 13.1642 12.3358 13.5 12.75 13.5Z"
		></path>
	</svg>
))
